import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M20.5,5.88H17.75a.5.5,0,0,1-.5-.5v-1A3.26,3.26,0,0,0,14,1.12H10A3.26,3.26,0,0,0,6.75,4.38v1a.5.5,0,0,1-.5.5H3.5A3.5,3.5,0,0,0,0,9.38v10a3.51,3.51,0,0,0,3.5,3.5h17a3.51,3.51,0,0,0,3.5-3.5v-10A3.5,3.5,0,0,0,20.5,5.88ZM9.25,4.38A.76.76,0,0,1,10,3.62h4a.76.76,0,0,1,.75.76v1a.5.5,0,0,1-.5.5H9.75a.5.5,0,0,1-.5-.5Zm7.24,9.2a.39.39,0,0,1-.18.22l-.51.29a.36.36,0,0,0-.19.36,3.25,3.25,0,0,1,0,.44,3.7,3.7,0,0,1-.05.59.36.36,0,0,0,.17.38l.53.31a.36.36,0,0,1,.13.49l-.73,1.26a.37.37,0,0,1-.5.14l-.56-.33a.36.36,0,0,0-.4,0,3.87,3.87,0,0,1-.91.51.36.36,0,0,0-.23.34v.65a.37.37,0,0,1-.36.37H11.27a.37.37,0,0,1-.36-.37v-.65a.36.36,0,0,0-.23-.34,3.46,3.46,0,0,1-1-.56.36.36,0,0,0-.4,0L8.75,18a.37.37,0,0,1-.5-.14l-.7-1.28a.36.36,0,0,1,0-.27.36.36,0,0,1,.18-.22l.52-.29a.37.37,0,0,0,.19-.38,3,3,0,0,1,0-.52,2.85,2.85,0,0,1,0-.51A.36.36,0,0,0,8.22,14l-.51-.3a.41.41,0,0,1-.17-.22.4.4,0,0,1,0-.28L8.31,12a.37.37,0,0,1,.5-.13l.49.29a.38.38,0,0,0,.41,0,3.46,3.46,0,0,1,1-.56.37.37,0,0,0,.23-.34v-.57a.36.36,0,0,1,.36-.36h1.46a.36.36,0,0,1,.36.36v.57a.38.38,0,0,0,.24.34,3.61,3.61,0,0,1,1,.6.36.36,0,0,0,.41,0l.49-.27a.36.36,0,0,1,.5.14l.7,1.27A.4.4,0,0,1,16.49,13.58Z",
        fill: "currentColor"
      }),
      _createElementVNode("circle", {
        cx: "12",
        cy: "14.94",
        r: "1.82",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }